import script from "./ETag.vue?vue&type=script&setup=true&lang=ts"
export * from "./ETag.vue?vue&type=script&setup=true&lang=ts"

import "./ETag.vue?vue&type=style&index=0&id=3697d3e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3697d3e8"]])

export default __exports__